<template>
    <div>
        <Wp_nav_bar :title="'助理清单(' + all_sku_list.length + ')'"></Wp_nav_bar>

        <div style="box-shadow: 1px 1px 5px #999999; margin: 5px 0px">
            <Wp_robot_public_on_off_model></Wp_robot_public_on_off_model>
        </div>


        <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
        <van-tabs title-active-color="#ee0a24" animated swipeable>
            <van-tab>
                <div slot="title"><h3>未推送({{sku_list_no_pushed.length}})</h3></div>

                <div v-if="sku_list_no_pushed && sku_list_no_pushed.length > 0" style="padding: 10px">
                    <van-row>
                        <van-col span="12">
                            <div v-if="show_sort_content">
                                <van-button type="danger"
                                            size="small"
                                            style="margin-left: 10px"
                                            @click="commitSort"
                                >
                                    提交排序
                                </van-button>
                            </div>
                        </van-col>
                        <van-col span="12" style="text-align: right;">
                            <van-button type="info"
                                        size="small"
                                        style="margin-right: 10px"
                                        @click="editSort"
                            >
                                {{show_sort_content ? '取消排序' : '发品排序'}}
                            </van-button>
                        </van-col>
                    </van-row>
                </div>

                <div>
                    <div v-if="!show_sort_content">
                        <div v-for="(item, index) in sku_list_no_pushed" v-bind:key="index">
                            <Row type="flex" justify="start" style="padding: 10px;">
                                <i-col span="6" style="height: 60px; line-height: 60px; text-align: center">
                                    <Wp_image :url="item.sku_img"></Wp_image>
                                    <!--                                <div>{{item.skuId}}</div>-->
                                </i-col>
                                <i-col span="18">
                                    <div class="select_skuName_div">{{item.sku_name}}</div>
                                    <div style="text-align: right; margin: 3px 10px 0px 0px">
                                        <van-tag size="medium" type="warning">预计今日 {{item.send_time}} 推送</van-tag>
                                    </div>

                                    <div style="text-align: right; margin: 8px 10px 0px 0px">
                                        <van-button
                                                size="small"
                                                type="danger"
                                                @click="removeSelectSku(index)"
                                        >移出助理
                                        </van-button>
                                    </div>

                                </i-col>
                            </Row>
                            <Divider dashed
                                     style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 5px; margin-bottom: 5px"></Divider>
                        </div>
                    </div>

                    <div v-else>
                        <div style="border: 1px solid #EE0A24; border-radius: 5px; padding: 10px; margin: 0px 10px">
                            注: 滑动左侧"预计推送时间"可上下滚动页面;<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;按住右侧商品条目可进行拖动排序;
                        </div>
                        <van-row>
                            <van-col span="5">
                                <div v-for="(item, index) in sku_list_no_pushed" v-bind:key="index">
                                    <div style="text-align: center; height: 90px;padding-top: 15px; border-right: 1px solid #cccccc; ">
                                        <van-tag size="medium" type="warning">预计今日<br/>{{item.send_time}}<br/>推送</van-tag>
<!--                                        <span style="color: #ffffff">预计今日<br/>{{item.send_time}}<br/>推送</span>-->
                                    </div>
                                    <Divider dashed
                                             style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin: 0px"></Divider>
                                </div>
                            </van-col>
                            <van-col span="19">
                                <SlickList
                                        :lockToContainerEdges="true"
                                        axis="y"
                                        lockAxis="y"
                                        class="SortableList"
                                        v-model="sku_list_sort"
                                        @input="getNewList"

                                >
                                    <SlickItem :disabled="sort_disabled" v-for="(item, index) in sku_list_sort" v-bind:key="index" class="SortableItem" :index="index" >
                                        <Row type="flex" justify="start" style="height: 90px;padding: 10px; background-color: white">

                                            <i-col span="5" style="height: 60px; line-height: 60px; text-align: center">
                                                <Wp_image :url="item.sku_img"></Wp_image>
                                                <!--                                <div>{{item.skuId}}</div>-->
                                            </i-col>
                                            <i-col span="19">
                                                <span class="select_skuName_div_line_3">{{item.sku_name}}</span>
                                            </i-col>
                                        </Row>
                                        <Divider dashed
                                                 style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin: 0px"></Divider>

                                    </SlickItem>
                                </SlickList>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-tab>
            <van-tab>
                <div slot="title"><h3>已推送({{sku_list_pushed.length}})</h3></div>
                <div v-for="(item, index) in sku_list_pushed" v-bind:key="index">
                    <Row type="flex" justify="start" style="padding: 10px;">
                        <i-col span="5" style="height: 60px; line-height: 60px; text-align: center">
                            <Wp_image :url="item.sku_img"></Wp_image>
                            <!--                                <div>{{item.skuId}}</div>-->
                        </i-col>
                        <i-col span="19">
                            <div class="select_skuName_div">{{item.sku_name}}</div>
                            <div style="text-align: right; margin: 10px 10px 0px 0px">
                                <van-tag size="medium" type="primary">今日 {{item.send_time}} 已推送</van-tag>
                            </div>
                        </i-col>
                    </Row>

                    <Divider dashed
                             style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 15px; margin-bottom: 15px"></Divider>
                </div>
            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Row, Col, Alert} from 'iview';
    import {Dialog, Toast} from "vant";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_image from "../custom/Wp_image";
    import Wp_robot_public_on_off_model from "../custom/Wp_robot_public_on_off_model";
    import { SlickList, SlickItem } from "vue-slicksort";

    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Alert', Alert);

    export default {
        name: "Wp_robot_tools",
        components: {Wp_robot_public_on_off_model, Wp_image, Wp_nav_bar, SlickList, SlickItem},
        // inject: ['WpJoinRobotListMark'],

        data() {
            return {
                //选品清单sheet是否弹出
                show_robot_sku_list_model: false,

                all_sku_list: [],
                sku_list_no_pushed: [],
                sku_list_pushed: [],
                //缓存未推送数据个数，用于判断是否有删除操作
                // temp_sku_list_no_pushed_length: -1,
                //是否进行了移出助理操作
                is_delete: false,

                switch_checked: true,
                //默认不可排序
                sort_disabled: false,

                sku_list_sort: [],

                show_sort_content: false,
                //用来判断是否进行过排序
                is_sort: false,
            }
        },

        created() {
            this.initAllRobotSkuList();
        },

        destroyed() {
            this.$log("---------destroyed-------")
            //若进行过移出助理操作，则获取一次全部数据
            if(this.is_delete){
                //必须要进行完成列表的查询，以保证再次进入详情时，可正确判断各种状态
                this.$getDataListFromRobot_All(data=>{
                    this.$log("---------data-------")
                    this.$log(data);
                    this.is_delete = false;
                })
            }

        },

        methods: {

            /**
             * 提交排序
             */
            commitSort(){
                if(this.is_sort){
                    Dialog.confirm({
                        title: "提交排序",
                        message: "确定提交现在的商品顺序吗？",
                        // confirmButtonText: ""
                    }).then(()=>{
                        this.sendSortData();
                    });
                }else{
                    Dialog.alert({
                        title: "提示",
                        message: "您并未进行排序，请排序后再提交"
                    })
                }

            },

            /**
             * 发送排序数据
             */
            sendSortData(){
                let loadingToast = Toast.loading({
                    message: '排序中...',
                    forbidClick: true,
                    duration: 0,
                });

                let _id_list = [];
                for(let i=0; i< this.sku_list_sort.length; i++){
                    this.$log("id: " + this.sku_list_sort[i].id)
                    _id_list.push(this.sku_list_sort[i].id)
                }
                let params = {
                    id_list: _id_list
                };
                this.$sendRobotSkuList_Sorted(params, response=>{

                    if(response && response.code === 200){
                        setTimeout(()=>{
                            this.$getDataListFromRobot_All(data=>{
                                this.$log('---------排序完成--------')
                                this.$log(data)
                                this.all_robot_sku_list = this.$common.global_sku_all_data.list;
                                this.formatRobotSkuList(this.all_robot_sku_list);
                                loadingToast.clear();
                                //重置进行排序操作的标记
                                this.is_sort = false;
                                //关闭排序界面
                                this.show_sort_content = false;
                            })
                        }, 1500)
                    }
                });
            },

            /**
             * 开启排序
             */
            editSort(){
                // this.show_sort_content = !this.show_sort_content;
                if(this.show_sort_content){
                    if(this.is_sort){
                        Dialog.confirm({
                            title: "取消排序",
                            message: "您已进行过排序操作，若取消排序，则商品顺序恢复，确定取消排序吗？",
                            // confirmButtonText: ""
                        }).then(()=>{
                            this.show_sort_content = false;
                            //取消排序时
                            this.sku_list_sort = this.sku_list_no_pushed;
                            this.is_sort = false;
                        });
                    }else{
                        this.show_sort_content = false;
                    }
                }else{
                    this.show_sort_content = true;
                }

            },

            getNewList(val){
                this.$log(val)
                this.is_sort = true;
            },

            initAllRobotSkuList(){
                let loadingToast = Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0,
                });
                if(this.$common.global_sku_all_data && this.$common.global_sku_all_data.list){
                    this.all_robot_sku_list = this.$common.global_sku_all_data.list;
                    this.formatRobotSkuList(this.all_robot_sku_list);
                    loadingToast.clear();
                }else{
                    this.$getAllDataListFromRobot_withLimitTime(response=>{
                        this.all_robot_sku_list = response.list;
                        this.formatRobotSkuList(this.all_robot_sku_list);
                        loadingToast.clear();
                    });
                }
            },

            formatRobotSkuList(list){
                let _sku_list_no_pushed = [];
                let _sku_list_pushed = [];
                for(let i = 0; i < list.length; i++){
                    // if(i === 0) {
                    //     list[i].task_status = 1;
                    // }

                    let content = list[i].message_list[1].msgContent;
                    let _skuName = content.substring(0, content.indexOf('\n'));

                    this.all_sku_list.push({
                        sku_img: list[i].message_list[0].msgContent,
                        sku_name: _skuName,
                        id: list[i].id,
                        sku_id: list[i].sku_id,
                        send_time: list[i].send_time
                    });

                    if(list[i].task_status === 0){
                        //未推送
                        _sku_list_no_pushed.push({
                            sku_img: list[i].message_list[0].msgContent,
                            sku_name: _skuName,
                            id: list[i].id,
                            sku_id: list[i].sku_id,
                            send_time: list[i].send_time
                        });
                    }

                    if(list[i].task_status === 1){
                        //已推送
                        _sku_list_pushed.push({
                            sku_img: list[i].message_list[0].msgContent,
                            sku_name: _skuName,
                            id: list[i].id,
                            sku_id: list[i].sku_id,
                            send_time: list[i].send_time
                        });
                    }
                }

                this.sku_list_no_pushed = _sku_list_no_pushed;
                this.sku_list_pushed = _sku_list_pushed;
                this.sku_list_sort = _sku_list_no_pushed;
            },


            /**
             * 清除选品清单列表中的所有商品
             */
            removeAllSelectSku() {

            },

            /**
             * 清除选品清单列表中的某一个商品
             */
            removeSelectSku(index) {

                this.moveOutRobot(index);
            },

            /**
             * 移出助理（即删除助理发品列表中当前商品对应的数据）
             */
            moveOutRobot(index){
                //移出助理标记置为true
                this.is_delete = true;

                if(this.sku_list_no_pushed){
                    let sid = this.sku_list_no_pushed[index].id;
                    let params = {
                        id: sid,
                    };
                    this.$deleteDataFromRobot(params, response=>{

                        if(response && response.code === 200){
                            if(response.data && response.data.result && response.data.result === 'DELETED'){
                                //删除成功
                                this.join_robot_status = true;
                                Toast.success({
                                    duration: 1000,
                                    message:"移出成功"
                                });

                                //变量中移除
                                this.sku_list_no_pushed.splice(index, 1);
                            }
                        }else{
                            Toast.success({
                                duration: 1000,
                                message:"移出失败"
                            });
                        }
                    })

                }

            },

            clickCloseIcon(){
                const toast = Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '数据重载'
                });
                // setTimeout(()=>{
                //     toast.clear();
                //     this.show_robot_sku_list_model = false;
                // }, 1500)
                setTimeout(()=>{
                    //必须要进行完成列表的查询，以保证再次进入详情时，可正确判断各种状态
                    this.$getDataListFromRobot_All(data=>{
                        // this.$emit("getAllRobatSkuData", data)
                        toast.clear();
                        this.$emit("updataBadgeCountAndData", this.sku_list_no_pushed.length, data);
                        this.show_robot_sku_list_model = false;
                    })
                }, 1500);
            },

            /**
             * 选品清单界面关闭
             */
            selectListClose() {
                // if(this.temp_sku_list_no_pushed_length !== -1 && this.temp_sku_list_no_pushed_length !== this.sku_list_no_pushed.length){
                //     this.$emit("updataJoinRobotButtonStatus");
                // }
                this.releaseSelectData();
            },


            releaseSelectData() {
                this.all_sku_list = [];
                // this.sku_list_no_pushed = [];
                // this.sku_list_pushed = [];
            },

            clearSelectSkuInfoData() {
                // this.WpJoinRobotListMark.robot_all_sku_list = [];
            },

            // changeSwitch(status){
            //     this.$log(status)
            //     if(status){
            //         this.changeRobotOnOff("open")
            //     }else{
            //         this.changeRobotOnOff("close")
            //     }
            // },
            //
            // changeRobotOnOff(send_status){
            //     let robot_list = this.$common.global_robot_list;
            //     if(robot_list){
            //         this.sendRobotStatus(robot_list, send_status)
            //     }
            // },
            //
            // sendRobotStatus(robot_list, status){
            //     let params = {
            //         robot_id: robot_list[0].vcRobotSerialNo,
            //         room_id: robot_list[0].vcChatRoomSerialNo,
            //         send_status: status
            //     };
            //     this.$sendRobotStatus(params, response=>{
            //         this.$log(response)
            //     })
            // },
        }
    }
</script>

<style scoped>
    .select_skuName_div {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-left: 10px;
    }

    .select_skuName_div_line_3 {
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        margin-left: 10px;
    }

</style>